<template>
    <div id="added_to_cart" class="added_to_cart_popup" ref="popup" v-bind:class="[{'shown' : show}]">
        <div class="atc_body">
            <button v-if="withCloseButtons" class="atc_close js_close" v-on:click.stop="closePopup">
                <span class="sr--only">{{options.labels.close}}</span>
                <svg class="svg-icon" viewBox="0 0 20 20">
                    <path stroke="#333" stroke-width="2" d="M 5 5 L 15 15 M 5 15 L 15 5"></path>
                </svg>
            </button>

            <slot></slot>

            <div v-if="withDotsLoader" class="awaiting_overlay displayed partial dots_loader mt_40">
                <p loader="loading"></p>
            </div>

            <button class="atc_button white keep" v-if="withCloseButtons" v-on:click.stop="closePopup">
                {{options.labels.ok}}
            </button>
        </div>
    </div>
</template>

<script>
    import popupMixin from "../mixins/popup-mixin";
    import { Constants } from "../functions/constants";

    const defaultLabels = {
        "close": "Close",
        "ok": "OK"
    }

    export default {
        name: "PopUp",
        mixins: [popupMixin],
        props: {
            withCloseButtons: {
                type: Boolean,
                default: false
            },
            withDotsLoader: {
                type: Boolean,
                default: false
            },
            show: {
                type: Boolean,
                default: false
            },
            options: {
                type: Object,
                default: {
                    labels: defaultLabels
                }
            }
        },
        methods: {
            closePopup: function () {
                this.show = false;
            },
            closeAllPopupsHandler: function () {
                this.show = false;
            }
        },
        watch: {
            'show': {
                handler: function (val) {
                    this.liftPopupSection(val);
                }
            }
        },
        created() {
            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CLOSE_ALL_POPUPS, this.closeAllPopupsHandler);
        },
        destroyed() {
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CLOSE_ALL_POPUPS, this.closeAllPopupsHandler);
        }
    };
</script>